<template>
  <div class="app flex-row align-items-center background-main">
    <div class="container">
      <div class="row">
        <div class="offset-sm-3 offset-md-3 offset-lg-3 offset-xl-3 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <div class="card">
            <div class="card-body">
              <form autocomplete="on" class="mt-2 mb-2">
                <center class="mb-3"><img src="/img/brand/logo.svg" width="150"></center>
                <h5 class="text-center title">ยินดีต้อนรับเข้าสู่ครอบครัวไอศกรีมวอลล์</h5>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-user"></i></span>
                  </div>
                  <input type="text" class="form-control" placeholder="ชื่อผู้ใช้" autocomplete="username" v-model.trim="form.username" name="username" @keyup.enter="login()" :disabled="load.active === true">
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-key"></i></span>
                  </div>
                  <input type="password" class="form-control" placeholder="รหัสผ่าน" autocomplete="current-password" v-model.trim="form.password" name="password" @keyup.enter="login()" :disabled="load.active === true">
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <button type="button" class="btn btn-primary btn-block" @click="login()" :disabled="load.active === true"><i class="fas fa-sign-in-alt"></i>
                    ลงชื่อเข้าใช้</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :percent="load.percent" :active="load.active"></Loading>
  </div>
</template>
<script>
import JWT from '../../utils/JWT.js';
export default {
  components: {
    'Loading': () => import('../../utils/Loading.vue')
  },
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      load: {
        percent:0,
        active: false
      },
      alert: {
        text: "ข้อมูลชื่อและรหัสผ่านของผู้ใช้ไม่พบในระบบ"
      }
    }
  },
  mounted() {
    localStorage.removeItem('walls_token')
    localStorage.removeItem('walls_encrypt')
  },
  methods: {
    async login() {
      if(this.form.username===''||this.form.password===''){
        this.$dialogs.alert('กรุณากรอกข้อมูล Username และ Password เพื่อเข้าสู่ระบบ',{title: 'ไม่พบข้อมูล'})
      }else{
        try {
          this.load.active = true
          const res = (await this.$http.post(process.env.VUE_APP_AUTH_URL + 'api/v1/user/auth/signin', {
            token: await JWT.encode({
              username: await JWT.encodeBase64(this.form.username),
              password: await JWT.encodeBase64(this.form.password)
            })
          })).body
          this.load.active=false
          if (res.data) {
            const data = await JWT.decode(res.data);
            if (data.token) {
              localStorage.setItem('walls_token', data.token)
              localStorage.setItem('walls_encrypt', await JWT.encode(data))
              this.$router.replace({
                name: 'Home'
              })
            } else {
              this.alert.text = 'ข้อมูลที่ส่งมาพบข้อผิดพลาด'
              this.$dialogs.alert(this.alert.text,{title: 'การเข้าสู่ระบบพบข้อผิดพลาด'})
            }
          } else {
            if (res.alert) {
              this.alert.text = res.alert
            }else{
              this.alert.text = 'ข้อมูลที่ส่งมาพบข้อผิดพลาด กรุณาตรวจสอบข้อมูลอีกครั้ง'
            }
            this.$dialogs.alert(this.alert.text,{title: 'การเข้าสู่ระบบพบข้อผิดพลาด'})
          }
        } catch (error) {
          this.load.active = false
          if (error.body) {
            if (error.body.alert) {
              this.alert.text = error.body.alert
            } else {
              this.alert.text = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
            }
          } else {
            this.alert.text = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
          }
          this.$dialogs.alert(this.alert.text,{title: 'การเข้าสู่ระบบล้มเหลว'})
        }
      }
    }
  }
}
</script>